import {AbstractEngine} from '../engines/AbstractEngine';

export abstract class AbstractAnimation implements Promise<any> {

    protected events: Record<string, ((opts?: any) => void)[]> = {};
    protected animationEngine?:AbstractEngine;

    public abstract applyFrom():this;

    [key: string]: any;

    constructor() {
        return new Proxy(this, {
            get: (target,prop,receiver)=>this.getHandler(target,prop,receiver),
            has: (target,prop)=>this.hasHandler(target,prop)
        });
    }

    async executor () {
        return this.promise('end');
    }

    public readonly [Symbol.toStringTag] = "Promise";

    private get promiseInstance(): Promise<any> {
        return this.executor();
    }

    public then: Promise<any>["then"] = (...args) => this.promiseInstance.then(...args);
    public catch: Promise<any>["catch"] = (...args) => this.promiseInstance.catch(...args);
    public finally: Promise<any>["finally"] = (...args) => this.promiseInstance.finally(...args);

    protected convertTime(time:string) {
        if (time.match(/(ms)$/)) return parseFloat(time);
        if (time.match(/(s)$/)) return parseFloat(time)*1000;
        throw new Error('Invalid time format.');
    }

    protected getHandler(target:object,prop:string|symbol,receiver:any) {
        if (Reflect.has(target,prop)) return Reflect.get(target,prop,receiver);
        if (this.animationEngine && Reflect.has(this.animationEngine,prop)) {
            return Reflect.get(this.animationEngine,prop);
        }
    }

    protected hasHandler(target:object,prop:string|symbol) {
        if (Reflect.has(target,prop)) return Reflect.has(target,prop);
        if (this.animationEngine && Reflect.has(this.animationEngine,prop)) {
            return Reflect.has(this.animationEngine,prop);
        }
        return false;
    }

    public engine(animationEngine:AbstractEngine|string=''):AbstractEngine|undefined {
        if (animationEngine) {
            if (typeof animationEngine=="string") {
                let animationEngines=(<any>window)['animationEngines'];
                this.animationEngine=new (animationEngines[animationEngine])(this);
            } else {
                this.animationEngine=animationEngine;
            }
        }
        return this.animationEngine;
    }

    public trigger(event:string,opts={}) {
        for (let [eventname,callbacks] of Object.entries(this.events)) {
            if (eventname==event) callbacks.forEach((callback)=>callback.call(this,opts));
        }
    }

    public promise(event:string) {
        return new Promise(
            (resolve, reject)=>{
                this.events[event].push(resolve);
            }
        );
    }

    public on(events:string,callback:(ani:AbstractAnimation)=>void) {
        for (let event of events.split(" ")) {
            if (typeof this.events[event]=='undefined') this.events[event]=[];
            this.events[event].push(callback);
        }
        return this;
    }

}

export {};